module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/1/4-892d0e849180fe04df99255b0a8c2710.jpg";